import React from 'react';
import PropTypes from 'prop-types';

function TouchPad({ active, activeColor, color }) {
  return (
    <path
      d="M498.537 237.426H297.703C293.643 237.426 290.321 234.104 290.321 230.044V126.133C290.321 122.073 293.643 118.752 297.703 118.752H498.537C502.597 118.752 505.919 122.073 505.919 126.133V230.044C505.919 234.104 502.597 237.426 498.537 237.426Z"
      fill={active ? activeColor : color}
    />
  );
}

TouchPad.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

TouchPad.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#1A1B1F',
};

export default TouchPad;
